import i18n from '../i18n/i18n'

export default {
  methods: {
    getConst (locale, str) {
      return i18n(locale, str)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/base-i18n.js